$(window).on('load',function(){
    $("#splash").delay(3000).fadeOut('slow');//ローディング画面を3秒待機してからフェードアウト
    $("#splash_logo").delay(2700).fadeOut('slow');//ロゴを2.7秒待機してからフェードアウト
});

$(function(){ 
    var now = new Date().getTime();
    $('#animation').attr('src','/wp-content/themes/yashiohoiku/assets/images/top_animation.png'+'?'+''+now);
});